<template>
  <label :class="style({ isError })" v-bind="$attrs">
    <slot />
  </label>
</template>

<script setup lang="ts">
import { tv } from 'tailwind-variants';
interface Props {
  isError?: boolean;
}
withDefaults(defineProps<Props>(), {
  isError: false,
});

const style = tv({
  base: 'block text-sm tracking-[2px] text-black1',
  variants: {
    isError: {
      true: 'text-red1',
    },
  },
});
</script>
